// @flow
import React from 'react';

const PlaceIcon = () => (
  <svg width="14" height="18" viewBox="0 0 14 18">
    <path d="M7 18C2.333 13.244 0 9.577 0 7a7 7 0 0 1 14 0c0 2.577-2.333 6.244-7 11zm5-11A5 5 0 1 0 2 7c0 1.664 1.643 4.44 5 8.097C10.357 11.44 12 8.664 12 7zM7 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" />
  </svg>
);
export default PlaceIcon;
